export const DEFAULT_CALC_COLUMNS = [
    {
        metricDisplayValue: '1 Day Returns (Daily)',
        metricInternalName: 'roc_1',
        columnType: 'metric',
    },
    {
        metricDisplayValue: '1 Month Total Returns (Daily)',
        metricInternalName: 'one_month_total_return',
        columnType: 'metric',
    },
    {
        metricDisplayValue: 'Year to Date Total Returns (Daily)',
        metricInternalName: 'ytd_total_return',
        columnType: 'metric',
    },
    {
        metricDisplayValue: '1 Year Total Returns (Daily)',
        metricInternalName: 'one_year_total_return',
        columnType: 'metric',
    },
    {
        metricDisplayValue: 'Annualized 3 Year Total Returns (Daily)',
        metricInternalName: 'annualized_daily_three_year_total_return',
        columnType: 'metric',
    },
    {
        metricDisplayValue: 'Annualized 10 Year Total Returns (Daily)',
        metricInternalName: 'annualized_daily_ten_year_total_return',
        columnType: 'metric',
    },
];
export const DEFAULT_INDICES = [
    {
        symbol: '^SPX',
        name: 'S&P 500',
        url: '',
    },
    {
        symbol: '^SPXTR',
        name: 'S&P 500 Total Return',
        url: '',
    },
    {
        symbol: '^IXIC',
        name: 'Nasdaq Composite',
        url: '',
    },
    {
        symbol: '^DJI',
        name: 'Dow Jones Industrial Average',
        url: '',
    },
    {
        symbol: '^BBUSATR',
        name: 'Bloomberg US Aggregate',
        url: '',
    },
    {
        symbol: '^NDX',
        name: 'Nasdaq-100',
        url: '',
    },
    {
        symbol: '^VIX',
        name: 'CBOE S&P 500 Volatility Index',
        url: '',
    },
    {
        symbol: '^RUT',
        name: 'Russell 2000',
        url: '',
    },
    {
        symbol: '^DXY',
        name: 'ICE US Dollar Index',
        url: '',
    },
    {
        symbol: '^MSACWI',
        name: 'MSCI ACWI',
        url: '',
    },
];
export const EDIT_COLUMNS_INSTRUCTION_TEXT = 'Drag and drop to reorder, or remove columns.';
export const EDIT_INDICES_INSTRUCTION_TEXT = 'Drag and drop to reorder, or remove indices.';
export const MAX_TABLE_INDICES = 10;
export const MAIN_INDEX_FAMILIES = [
    'Alerian',
    'Bloomberg',
    'BlueStar',
    'CBOE',
    'CRSP',
    'Dow Jones',
    'Fidelity',
    'Invesco',
    'ICE',
    'MSCI',
    'Morningstar',
    'NYSE',
    'NYSE Arca',
    'Nasdaq',
    'New Age Alpha',
    'Northern Trust',
    'Research Affiliates',
    'Russell',
    'S&P',
    'Société Générale',
    'StrataQuant',
    'Thomson Reuters',
    'Wilshire',
    'Wisdom Tree',
];
